import React, { useEffect, useRef } from 'react';

interface TimelineContextMenuProps {
  onClose: () => void;
  onDelete: () => void;
}

const TimelineContextMenu: React.FC<TimelineContextMenuProps> = ({
  onClose,
  onDelete,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div
      ref={menuRef}
      style={{
        position: 'absolute',
        display: 'flex',
        alignSelf: 'center',
        justifyContent: 'center',
        padding: '8px',
        backgroundColor: '#747474',
        zIndex: 1000,
        gap: '10px',
        borderRadius: '5px',
        top: '0%',
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={(event) => {
        event.stopPropagation();
        onDelete();
      }}
    >
      <span className="mr-2">🗑️</span> Delete
    </div>
  );
};

export default TimelineContextMenu;
